import { Injectable, OnDestroy } from "@angular/core";
import { Unsubscribe } from "redux";
import { Observable, ReplaySubject, distinctUntilChanged, map } from "rxjs";
import { receiveSessions } from "@gtmhub/sessions/redux/session-actions";
import { ISessionsStoreState } from "@gtmhub/sessions/redux/session-reducer";
import { reduxStoreContainer } from "@gtmhub/state-management/state-management.module";
import { Cache } from "@webapp/core/state-management/models/cache.model";
import { Session } from "../models/sessions.model";

@Injectable({ providedIn: "root" })
export class SessionsCache implements OnDestroy, Cache<Map<string, Session>> {
  private unsubscribeFromReduxStore: Unsubscribe;
  private cache$ = new ReplaySubject(1);

  constructor() {
    this.unsubscribeFromReduxStore = reduxStoreContainer.reduxStore.subscribe(() => {
      const sessionsMap = reduxStoreContainer.reduxStore.getState<ISessionsStoreState>().sessions.map || {};
      this.cache$.next(sessionsMap);
    });
  }

  public ngOnDestroy(): void {
    if (this.unsubscribeFromReduxStore) {
      this.unsubscribeFromReduxStore();
    }
  }

  public get$(): Observable<Map<string, Session>> {
    return this.cache$.asObservable().pipe(
      distinctUntilChanged(),
      map((x) => new Map(Object.entries(x)))
    );
  }

  public set(value: Map<string, Session>): void {
    reduxStoreContainer.reduxStore.dispatch(receiveSessions([...value.values()]));
  }

  public hasValue(): boolean {
    return reduxStoreContainer.reduxStore.getState<ISessionsStoreState>().sessions.isFetched;
  }
}
